import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Carta from './pages/Menu';
import Gastronomy from './pages/Gastronomy';
import Contact from './pages/Contact';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ArrowScroll from './components/ScrollArrow';
import Vinos from './pages/Vinos';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <ArrowScroll />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Carta />} />
          <Route path="/wines" element={<Vinos />} />
          <Route path="/gastronomy" element={<Gastronomy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;